import { render, staticRenderFns } from "./BusinessProfileCdcModule.vue?vue&type=template&id=5c2344a9&scoped=true&"
import script from "./BusinessProfileCdcModule.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileCdcModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2344a9",
  null
  
)

export default component.exports